import { render, staticRenderFns } from "./GoodsInformation.vue?vue&type=template&id=05b6ca07&"
import script from "./GoodsInformation.vue?vue&type=script&lang=js&"
export * from "./GoodsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports